export default {
    "The Active required.": "El activo requerido.",
    "The Default Role required.": "El rol predeterminado requerido.",
    "The User Name required.": "El nombre de usuario requerido.",
    "The Login Name is required.": "Se requiere el nombre de usuario.",
    "The User Email is required.": "Se requiere el correo electrónico del usuario.",
    "The Effective From required.": "El efectivo desde requerido.",
    "The Default BU required.": "Se requiere la BU predeterminada.",
    "The Authentication Type required.": "El tipo de autenticación requerido.",
    "The User Email field is not a valid e-mail address.": "El campo Correo electrónico del usuario no es una dirección de correo electrónico válida.",
    "User": "Usuario",
    "User Permission": "Permiso de usuario",
    "User Form": "Formulario de usuario",
    "Authentication Type": "tipo de autenticación",
    "Sign Out": "Desconectar",
    "Edit Profile": "Editar perfil",
    "Accounting Location":"Ubicación contable",
    "About": "Acerca de",
    "&#169 PanApps, All Rights Reserved": "&#169 PanApps, todos los derechos reservados",
    "Announcements": "Anuncios",
    "Code": "Código",
    "Name": "Nombre",
    "Level": "Nivel",
    "Active": "Activo",
    "View": "Ver",
    "Modify": "Modificar",
    "Import": "Importar",
    "Export": "Exportar",
    "Bulk Update": "Actualización masiva",
    "Bulk Delete": "Eliminar a granel",
    "Special1": "Especial1",
    "Special2": "Especial2",
    "Special3": "Especial3",
    "Special4": "Especial4",
    "Special5": "Especial5",
    "User Name": "Nombre de usuario",
    "Login Name": "Nombre de inicio de sesión",
    "Default BU": "BU predeterminado",
    "Effective From": "Efectivo desde",
    "Effective To": "Efectivo para",
    "User Email": "Email del usuario",
    "Profile Picture": "Foto de perfil",
    "Locked": "Bloqueado",
    "Default Role": "Rol predeterminado",
    "Authentication": "Autenticación",
    "Password": "Contraseña",
    "Confirm Password": "Confirmar contraseña",
    "Business Unit": "Unidad de negocio",
    "Role": "papel",
    "Module Group": "Grupo de módulos",
    "Module": "Módulo",
    "Description": "Descripción",
    "Opportunities": "Oportunidades",
    "Workspace": "Espacio de trabajo",
    "Client Profile": "Perfil del cliente",
    "Field Name": "Nombre del campo",
    "Tooltip": "informaciÃ³n sobre herramientas",
    "Tooltip Editor": "Editor de informaciÃ³n sobre herramientas",
    "Opportunities Â» Workspace Â» Client Profile": "Oportunidades Â» Espacio de trabajo Â» Perfil del cliente",
    "Rows per page": "Filas por pÃ¡gina",
    "Client Contracting Entities ": "Entidades Contratantes del Cliente",
    "Client Name": "nombre del cliente",
    "Search": "Buscar",
    "Edit": "Editar",
    "Close": "Cerrar",
    "Save": "Salvar",
    "Cancel": "Cancelar",
    "Select Date": "Seleccione fecha",
    "Excel Export": "ExportaciÃ³n Excel",
    "Filter": "Filtrar",
    "Rows per page:": "Filas por pÃ¡gina:",
    "Add": "AÃ±adir",
    "Delete": "Eliminar",
    "Save & Continue": "Guardar Continuar",
    "Profile ID": "Perfil Id",
    "Client Abbreviation": "Abreviatura del cliente",
    "Business Type": "Tipo de negocio",
    "Fiscal Year End": "Cierre del aÃ±o fiscal",
    "GPO Participation": "ParticipaciÃ³n de GPO",
    "DBA": "DBA",
    "Swingtide Relationship Manager": "Gerente de relaciones Swingtide",
    "Estimated Revenue": "Ingresos estimados",
    "Client Description": "DescripciÃ³n del cliente",
    "Client Contracting Entities": "Entidades Contratantes del Cliente",
    "Client Contracting Entity": "Entidad Contratante del Cliente",
    "Relationship Type": "Tipo de relaciÃ³n",
    "Amount": "Cantidad",
    "Total Rate": "Tasa total",
    "Notes": "Notas",
    "Document Info": "InformaciÃ³n del documento",
    "File Name": "Nombre del archivo",
    "Category": "CategorÃ­a",
    "Uploaded Date": "Fecha de carga",
    "Client Initiative": "Iniciativa del cliente",
    "Ownership Percentage": "Porcentaje de participaciÃ³n",
    "No matching records found": "No se encontraron registros coincidentes",
    'Kindly fill general info card': 'Por favor llene la tarjeta de informaciÃ³n general',
    'Your changes will be lost. Are you sure?': 'Tus cambios se perderÃ¡n. Â¿EstÃ¡s seguro?',
    'Confirm': 'Confirmar',
    'Are you sure you want to close?': 'Â¿EstÃ¡s seguro de que quieres cerrar?',
    'Are you sure you want to delete this record?': 'Â¿Seguro que quieres eliminar este registro?',
    'Click here to download ': 'Haga click aquÃ­ para descargar',
    'Invalid date': 'Fecha invalida',
    'Invalid date format. Please enter the date in the format ': 'Formato de fecha invÃ¡lido. Por favor, introduzca la fecha en el formato',
    'Loading... Please wait': 'Cargando por favor espere',
    'No file selected.': 'NingÃºn archivo seleccionado',
    'No data available': 'Datos no disponibles',
    'Kindly fill the previous row': 'Por favor llene la fila anterior',
    'Success': 'Ã‰xito',
    'The record is created successfully.': 'El registro se creÃ³ con Ã©xito.',
    'The record is updated successfully.': 'El registro se actualiza con Ã©xito.',
    'The record is deleted successfully.': 'El registro se eliminÃ³ con Ã©xito.',
    'You don\'t have sufficient permission for do this operation': 'No tienes permiso suficiente para hacer esta operaciÃ³n',
    "Initiative": "Iniciativa",
    "Status": "Estado",
    "Headquarters Address": "direcciÃ³n de las oficinas centrales",
    "Address Line": "DirecciÃ³n",
    "City": "Ciudad",
    "State": "Estado",
    "Zip": "CÃ³digo Postal",
    "Country": "PaÃ­s",
    "Contact Info": "Datos de contacto",
    "Existing Contact": "Contacto existente",
    "First Name": "Nombre de pila",
    "Last Name": "Apellido",
    "Position": "la posiciÃ³n",
    "Phone": "TelÃ©fono",
    "Email": "Email",
    "In Process Actions Stats": "EstadÃ­sticas de acciones en proceso",
    "Workflow Status": "Estado del flujo de trabajo",
    "Contracting Actions": "Acciones de contrataciÃ³n",
    "Sourcing Actions": "Acciones de abastecimiento",
    "Vendor Management Actions": "Acciones de gestiÃ³n de proveedores",
    "Rate Card": "Tarjeta de tarifa",
    "Contract Responsibility": "Responsabilidad contractual",
    "Start Date": "Fecha de inicio",
    "End Date": "Fecha final",
    "Rate": "la tarifa",
    "Completed Actions Stats": "EstadÃ­sticas de acciones completadas",
    "Current Month": "Mes actual",
    "Calendar YTD": "Calendario hasta la fecha",
    "All Time": "Todo el tiempo",
    "New": "Nuevo"
}